import { createContext, useMemo, useReducer } from 'react';
import { appFormsHandlers, appFormsInitialState, appFormsReducer } from '../reducers/AppFormsReducer';

/** Returns all the forms (objects) needed for the App */
export const AppFormsContext = createContext();

const AppFormsProvider = (props) => {

  const [appForms_state, appForms_dispatch] = useReducer(appFormsReducer, appFormsInitialState());
  const appForms_handlers = useMemo(
    () => appFormsHandlers(appForms_dispatch),
    [appForms_dispatch]
  );

  const providerContext = () => <AppFormsContext.Provider value={{ appForms_state, appForms_handlers }}>
    {props.children}
  </AppFormsContext.Provider>

  return providerContext()

}

export default AppFormsProvider
